export enum MagazineWidthClass {
  TINY = 'magazine-width-tiny',
  SMALL = 'magazine-width-small',
  MEDIUM = 'magazine-width-medium',
  LARGE = 'magazine-width-large',
  HUGE = 'magazine-width-huge',
  GIANT = 'magazine-width-giant',
}

export const magazineWidthForSinglePageView = [MagazineWidthClass.TINY, MagazineWidthClass.SMALL, MagazineWidthClass.MEDIUM]
